module.exports = __webpack_public_path__ + "img/grupo-inno.2b33c0ae.jpg";